import React from "react";
import { SUB_DIRCTORY } from "../../../app_config";

const GateAccessTransactionRoutes = [
  {
    path: `${SUB_DIRCTORY}/gate-access-transaction`,
    component: React.lazy(() => import("./GateAccessTransaction")),
  },
];

export default GateAccessTransactionRoutes;
